// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__yfR-X","consentsList":"PatientConsents_consentsList__3WxCd","consentsListEmpty":"PatientConsents_consentsListEmpty__2yQy7"};